
import Vue from 'vue'
import { isEmailValid } from '@/services/EmailHelpers'

export default Vue.extend({
   name: 'EmailboxFormGroup',
   props: {
      id: String,
      label: String,
      value: String,
      placeholder: { type: String, default: '' },
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      validate: { type: Boolean, default: false },
      instructions: { type: String, default: '' },
   },
   data() {
      return {
         initialValue: '',
         innerValue: '',
         dirty: false,
      }
   },
   computed: {
      isValidEmail(): boolean {
         return isEmailValid(this.innerValue)
      },
      validationFailed(): boolean {
         if (!this.required) {
            return false
         }
         if (!this.dirty && !this.validate) {
            return false
         }
         return !this.isValidEmail
      },

      helpBlock(): string {
         return `A valid ${this.label} is required`
      },
      showWarning(): boolean {
         return this.innerValue.includes('gnail.com')
      },
      warningText(): string {
         return `Did you mean gmail.com (with an m)?`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: string) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         if (this.isValidEmail) {
            this.$emit('input', this.innerValue)
         }
      },
   },
   components: {},
})
